'use client';
import React, { useState, useRef, useEffect } from 'react';
import { useInstantSearch, useSearchBox, type UseSearchBoxProps } from 'react-instantsearch';
import { IconResolver } from '../../IconResolver';
import { Button } from '../Button';

export function Search({
	initialQuery,
	placeholder,
	updateSearchParams,
	...props
}: UseSearchBoxProps & { initialQuery?: string; placeholder?: string; updateSearchParams?(query: string, value: string): void }) {
	const { query, refine } = useSearchBox(props);
	const { status } = useInstantSearch();
	const [inputValue, setInputValue] = useState(query);
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (initialQuery) {
			refine(initialQuery);
			setInputValue(initialQuery);
		}
	}, [initialQuery, refine]);

	const isSearchStalled = status === 'stalled';

	function setQuery(newQuery: string) {
		updateSearchParams?.('query', newQuery);
		setInputValue(newQuery);

		refine(newQuery);
	}

	return (
		<div>
			<form
				action=''
				role='search'
				noValidate
				onSubmit={event => {
					event.preventDefault();
					event.stopPropagation();

					if (inputRef.current) {
						inputRef.current.blur();
					}
				}}
				onReset={event => {
					event.preventDefault();
					event.stopPropagation();

					setQuery('');

					if (inputRef.current) {
						inputRef.current.focus();
					}
				}}
				className='pl-4 pr-2 py-2 bg-background-tertiary rounded-xl backdrop-blur-lg justify-center items-center gap-3 inline-flex md:w-[27rem] w-full'
			>
				<div className='grow shrink basis-0 justify-start items-center flex'>
					<input
						ref={inputRef}
						autoComplete='off'
						autoCorrect='off'
						autoCapitalize='off'
						placeholder={placeholder ? placeholder : 'Search'}
						spellCheck={false}
						maxLength={512}
						type='search'
						value={inputValue}
						onChange={event => {
							setQuery(event.currentTarget.value);
						}}
						className='text-foreground-tertiary font-normal leading-relaxed bg-transparent w-full focus:outline-none focus:ring-0 focus:border-0 text-xs'
					/>
				</div>
				{inputValue && inputValue.length > 0 ? (
					<Button parent='FAQSearch' type='reset' styleType='tertiary' className='filter grayscale [&>div]:text-foreground-tertiary'>
						<IconResolver icon={'x'} />
					</Button>
				) : (
					<Button parent='FAQSearch2' type='submit' styleType='primary'>
						Search
					</Button>
				)}
				<span hidden={!isSearchStalled}>Searching…</span>
			</form>
		</div>
	);
}
